import { render, staticRenderFns } from "./ChannelPartnerDashboard.vue?vue&type=template&id=5799c373&"
import script from "./ChannelPartnerDashboard.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports